<template>
  <v-footer class="d-flex flex-column  justify-space-start mt-10 pa-0">
    <div class=" w-100 mr-16 pr-16">
      <div class=" w-100 rounded-te-pill bg-secondary pa-2 mr-16"></div>

    </div>
    <div class="d-flex w-100 bg-primary  align-center rounded-e-pill" border-e-xl>
      <v-btn
        v-for="icon in icons"
        :key="icon.icon"
        :icon="icon.icon"
        class="mx-4"
        color="white"
        :size="sizeIcon"
        variant="plain"
        :href="icon.url"
        target="_blank"
      ></v-btn>
      <v-spacer>    
        <p class=" d-none d-md-block text-body-2 font-weight-medium ml-4">
            EngeBIO Nordeste está construindo um conjunto de soluções para sua empresa. Junte-se a nós
        </p>
      </v-spacer>
      <div>
        <v-img
          class="mr-5"
            :src="require(`@/assets/images/engelogo.png`)"
            :width="150"
      >
      </v-img>
      </div>
    </div>
    <div class="py-2 d-block d-md-none text-center w-100">
        EngeBIO Nordeste está construindo um conjunto de soluções para sua empresa. Junte-se a nós
    </div>
    <div class="py-2  text-center w-100">
        &copy;  {{ new Date().getFullYear() }} — <strong> EngeBIO Nordeste. Todos os direitos reservados.</strong>
    </div>
  </v-footer>
</template>
<script>
import { useDisplay } from 'vuetify'
import { computed } from 'vue'

export default {
  name:'footer-component',
  setup() {
    const { name } = useDisplay()

    const sizeIcon = computed(() => {
      // name is reactive and
      // must use .value
      switch (name.value) {
        case 'xs': return 'x-small'
        // case 'sm': return name.value
        // case 'md': return name.value
        default :  return 'x-large'
      }
    })
   const icons = [
      {icon:'mdi-facebook', url:''},
      {icon:'mdi-youtube', url:''},
      {icon:'mdi-linkedin', url:'https://www.linkedin.com/company/engebio-nordeste/'},
      {icon:'mdi-instagram', url:'https://www.instagram.com/engebionordeste/'},
    ]

    return {
      sizeIcon,
      icons
    }
  },

}
</script>